var custom_nosto = {
  currCollectionId: '',
  collectionPageLoaded: false,
  handleNostoDoNotTrack: function (domain) {
    const oneTrustCookie = custom.getCookie("OptanonConsent");
    const preferenceCategoryGranted = "C0003:1";
    const consentGranted = oneTrustCookie.includes(preferenceCategoryGranted);
    nostojs(api => api.visit.setDoNotTrack(!consentGranted));
    nostojs(api => api.setAutoLoad(false));
    document.addEventListener("visitorConsentCollected", (event) => {
      if (event.detail.preferencesAllowed == true) {
        nostojs(api => api.visit.setDoNotTrack(false));
      } else {
        nostojs(api => api.visit.setDoNotTrack(true));
        custom.removeCookie("2c.cId", domain, true);
      }
    });
  },
  handleNostoProductResponse: function (
    placementId,
    sectionId,
    max_products,
    doCarousel,
    languageCode,
    discountPlacement,
    response
  ) {

    if (response.recommendations.hasOwnProperty(placementId)) {
      let isSideCart = sectionId === 'side-cart';
      let isPdpRec = sectionId === 'pdp-rec';
      let nosto_placement = response.recommendations[placementId];
      if (nosto_placement) {
        //Check if the response is a string before parsing
        try {
          if (typeof nosto_placement === 'string') {
            nosto_placement = JSON.parse(nosto_placement);
          }
        } catch (error) {
          nosto_placement = {};
        }


        let nostoArr = nosto_placement.products;
        let slotId = nosto_placement.params ? nosto_placement.params.nosto : '';
        let header = nosto_placement.title;
        let parentElem = document.getElementById('shopify-section-' + sectionId);
        if (parentElem) {
          let headerElem = parentElem.querySelector('.mo-heading');
          if (headerElem) {
            headerElem.innerHTML = header;
          }
        }
        nostoArray = nostoArr.slice(0, max_products);
        let index = 0;
        if (isSideCart && nostoArray.length > 0) {
          document.getElementById('shopify-section-side-cart').style.display = 'block';
        }
        if (isPdpRec && nostoArray.length > 0) {
          document.getElementById('shopify-section-pdp-rec').style.display = 'block';
        }
        nostoArray.forEach((product, idx) => {
          let productUrlSplit = product.url.split("/");
          const handleFiltered = productUrlSplit[productUrlSplit.length - 1];
          if (handleFiltered) {
            let ulProducts = document.querySelector(`.products_${sectionId}`);

            if (doCarousel) {
              ulProducts = document.querySelector(
                `.products_${sectionId} .flickity-slider`
              );
            }

            if (ulProducts) {
              const placeholders = ulProducts.querySelectorAll(
                ".product-placeholder"
              );
              placeholders.forEach((placeholder) => {
                placeholder.remove();
              });
              const hiddendivs = ulProducts.querySelectorAll("div");
              hiddendivs.forEach((div) => {
                if (!div.classList.contains("product")) {
                  div.remove();
                }
              });

              let productLi = document.createElement("div");
              let percentNum = idx * 100;
              if (doCarousel) {
                productLi.setAttribute(
                  "style",
                  `position: absolute; left: 0px; transform: translateX(${percentNum}%);`
                );
                productLi.setAttribute(
                  "class",
                  `small-6 medium-6 large-3 columns carousel__slide product product-${sectionId}-${handleFiltered}`
                );
                ulProducts.appendChild(productLi);
              } else if (isSideCart || isPdpRec) {
                ulProducts.innerHTML += `<product-card-small class="product product-${sectionId}-${handleFiltered}"></product-card-small>`;
              } else {
                productLi.setAttribute(
                  "class",
                  `small-6 medium-6 large-3 columns product  product-${sectionId}-${handleFiltered}`
                );
                ulProducts.appendChild(productLi);
              }

              if (document.getElementById('shopify-section-side-cart') && isSideCart) {
                const sideCartHeading = document.getElementById('shopify-section-side-cart').querySelector('.sidecart-heading');
                if (sideCartHeading) {
                  sideCartHeading.innerHTML = header;
                }
              }
              let doSmall = isSideCart || isPdpRec;
              let noPlpCarousel = true;
              productCardElems.getPdpItem(handleFiltered, doSmall, sectionId, false, slotId, false, doCarousel, noPlpCarousel);
            }
          }
        });
        setTimeout(() => {
          custom_nosto.updateNostoSlideshow();
          custom.callJudgeMeScript();
        }, 500);
      }
    } else {
      custom.hide("shopify-section-" + sectionId);
    }
  },
  createFilters: function (collectionId, use_default) {
    if (!collectionId) {
      collectionId = this.currCollectionId;
    }
    this.currCollectionId = collectionId;

    let formElem = document.getElementById("FacetFiltersFormMobile2");
    if (formElem) {
      formElem.innerHTML = "";
      let query = custom_nosto.getFilterQuery(use_default);

      fetch("https://search.nosto.com/v1/graphql", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          query: query,
        }),
      })
        .then((res) => res.json())
        .then((result) => {

          let errors = result.errors;
          let hasError = false;
          if (errors && errors.length > 0) {
            hasError = true;
            console.error('Nosto API fetch failed with error: ' + JSON.stringify(errors, null, 4));
          }
          if (hasError) {
            if (!use_default) {
              custom_nosto.createFilters(collectionId, true);
              return;
            }
          }
          else if (result && result.data) {
            let facets = result.data.search.products.facets;
            if (facets && facets.length > 0) {
              facets.forEach((facet) => {
                if (!facet) {
                  return;
                }
                let facetName = facet.name;
                let facetField = facet.field;
                let facetValues = facet.data;
                let liHTML = "";
                if (facetValues && facetValues.length > 0) {
                  facetValues.forEach((item) => {
                    let value = item.value;
                    let count = item.count;
                    liHTML += `<li>
                <input type="checkbox" onclick="custom_nosto.updateFilterItem('${facetField}', '${value}');" class="filter-item" name="${facetField}" value="${value}" id="${facetField}${value}">
                <label for="${facetField}${value}" class="facet-checkbox" style="--bg-color: 1/2;" data-tooltip="${value} (${count})">
                  <span class="filter-color filter-1/2"></span>
                  <span class="color-sample filter-${value.toLowerCase()}"></span> 
                  <span class="filter-name ">${value}</span> 
                  <span id="${facetField}${value}_ct" class="count">(${count})</span>
                </label>
                </li>`;
                  });
                }
                let categoryHTML = `
              <collapsible-row data-index="3">
                  <details class="thb-filter js-filter" open="">
                    <summary class="thb-filter-title">${facetName}<span>
                      <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 6.81818L7 0.818176L1 6.81818" stroke="var(--color-heading)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>
                    </summary>
                  <div class="thb-filter-content collapsible__content">
                    <scroll-shadow>
                      <ul class="list-taille">${liHTML}</ul>
                    </scroll-shadow></div>
                </details>
              </collapsible-row>`;
                formElem.innerHTML += categoryHTML;
              });

            }
          }
          if (custom.loadProducts) {
            custom.loadProducts = false;
            custom_nosto.filterNostoProducts(collectionId, 'nostoProducts', "", 0)
          }
        });
    }
  },
  updateFilters: function () {
    let query = custom_nosto.getFilterQuery();
    fetch("https://search.nosto.com/v1/graphql", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: query,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        let errors = result.errors;
        if (errors && errors.length > 0) {
          console.error('Nosto API fetch failed with error: ' + JSON.stringify(errors, null, 4));
          return;
        }
        else if (result && result.data) {
          let facets = result.data.search.products.facets;
          if (facets && facets.length > 0) {
            facets.forEach((facet) => {
              let facetField = facet.field;
              let facetValues = facet.data;
              facetValues.forEach((item) => {
                let value = item.value;
                let count = item.count;
                let countElem = document.getElementById(`${facetField}${value}_ct`);
                countElem.innerHTML = `(${count})`;
              });
            });
          }
        }
      });
  },
  callNostoNavigation: function () {
    let navigation_test = custom.getAttribute("navigation_test");
    if (navigation_test) {
      //Show default navigation if nosto is turned off
      custom_navigation.createNavigation(navigation_test);
    } else {
      setTimeout(function () {
        let fullMenuElem = document.getElementById("nosto-menu-desktop");
        if (fullMenuElem) {
          if (fullMenuElem.innerHTML == "") {
            custom_navigation.createNavigation("default");
          }
        }
      }, 500);
      nostojs((api) => {
        api
          .defaultSession()
          .viewFrontPage()
          .setPlacements(["navigation-menu"])
          .load()
          .then((data) => {
            if (custom.getAttribute("debugnav")) {
              let now = Date.now();
              console.warn("Navigation Load Time: ", now - before + " ms");
              console.log("Response:", data);
            }
            let menuKeyStr = "default";
            if (
              data.recommendations["navigation-menu"] &&
              data.recommendations["navigation-menu"] != "undefined"
            ) {
              let menu = data.recommendations["navigation-menu"];
              if (menu.html) {
                menuKeyStr = menu.html;
              } else {
                menuKeyStr = menu;
              }
            } else {
              menuKeyStr = "default";
            }

            if (menuKey && menuKeyStr != "undefined") {
              sessionStorage.setItem(menuKey, menuKeyStr); //Update existing menu storage key
            }
            if (!currentMenuStorage) {
              custom_navigation.createNavigation(menuKeyStr);
            }
          });
      });
    }
  },
  validateNostoSection: function (sectionId, doCarousel) {
    //If Nosto hasent set the slider products, hide the slider
    let ulProducts = document.querySelector(`.products_${sectionId}`);
    if (doCarousel) {
      ulProducts = ulProducts.querySelector('.flickity-slider');
    }
    if (ulProducts) {
      let placeholder = ulProducts.querySelector('.product-placeholder');
      if (placeholder) {
        custom.hide("shopify-section-" + sectionId);
      }
    }
  },
  callNostoProducts: function (
    doCarousel,
    placementId,
    productId,
    sectionId,
    productLimit,
    languageCode,
    discountPlacement,
    collectionId
  ) {
    setTimeout(() => {
      custom_nosto.validateNostoSection(sectionId, doCarousel);
    }, 8000);

    let parentElem = document.getElementById('shopify-section-' + sectionId);
    if (parentElem) {
      let headerElem = parentElem.querySelector('.mo-heading');
      if (headerElem) {
        headerElem.innerHTML = "";
      }
    }
    let isSideCart = sectionId === 'side-cart';
    if (custom.getAttribute('from_key') == 'true') {
      custom.isCategoryPage = false;
      custom.isSearchPage = true;
    }
    if (custom.isProductPage && !isSideCart) { //##### PDP PAGE ####
      if (custom.getAttribute("debugrec")) {
        console.log("recommendation request", {
          placementId: placementId,
          productId: productId,
          sectionId: sectionId,
          productLimit: productLimit,
          languageCode: languageCode,
          discountPlacement: discountPlacement,
          viewPage: 'Product'
        });
      }
      nostojs((api) => {
        api
          .defaultSession()
          .viewProduct(productId)
          .setPlacements([placementId])
          .load()
          .then((response) => {
            if (custom.getAttribute("debugrec")) {
              console.log("recommendation response", response);
            }
            if (response) {
              custom_nosto.handleNostoProductResponse(
                placementId,
                sectionId,
                productLimit,
                doCarousel,
                languageCode,
                discountPlacement,
                response
              );
            }
          });
      });
    } else if (custom.isCategoryPage && !isSideCart) { //##### COLLECTION PAGE ####
      if (custom.getAttribute("debugrec")) {
        console.log("recommendation request", {
          placementId: placementId,
          sectionId: sectionId,
          productLimit: productLimit,
          languageCode: languageCode,
          discountPlacement: discountPlacement,
          collectionId: collectionId,
          viewPage: 'Collection Page'
        });
      }

      nostojs((api) => {
        api
          .defaultSession()
          .viewCategory(collectionId)
          .setPlacements([placementId])
          .load()
          .then((response) => {
            if (custom.getAttribute("debugrec")) {
              console.log("recommendation response", response);
            }
            if (response) {
              custom_nosto.handleNostoProductResponse(
                placementId,
                sectionId,
                productLimit,
                doCarousel,
                languageCode,
                discountPlacement,
                response
              );
            }
          });
      });
    } else if (custom.isSearchPage && !isSideCart) { //##### SEARCH PAGE ####
      if (custom.getAttribute("debugrec")) {
        console.log("recommendation request", {
          placementId: placementId,
          productId: productId,
          sectionId: sectionId,
          productLimit: productLimit,
          languageCode: languageCode,
          discountPlacement: discountPlacement,
          viewPage: 'Search Page'
        });
      }
      nostojs((api) => {
        api
          .defaultSession()
          .viewSearch(searchTerm)
          .setPlacements([placementId])
          .load()
          .then((response) => {
            if (custom.getAttribute("debugrec")) {
              console.log("recommendation response", response);
            }
            if (response) {
              custom_nosto.handleNostoProductResponse(
                placementId,
                sectionId,
                productLimit,
                doCarousel,
                languageCode,
                discountPlacement,
                response
              );
            }
          });
      });
    } else if (custom.isHomePage && !isSideCart) { //##### HOME PAGE ####
      if (custom.getAttribute("debugrec")) {
        console.log("recommendation request", {
          placementId: placementId,
          productId: productId,
          sectionId: sectionId,
          productLimit: productLimit,
          languageCode: languageCode,
          discountPlacement: discountPlacement,
          viewPage: 'Front Page'
        });
      }
      nostojs((api) => {
        api
          .defaultSession()
          .viewFrontPage()
          .setPlacements([placementId])
          .load()
          .then((response) => {
            if (custom.getAttribute("debugrec")) {
              console.log("recommendation response", response);
            }
            if (response) {
              custom_nosto.handleNostoProductResponse(
                placementId,
                sectionId,
                productLimit,
                doCarousel,
                languageCode,
                discountPlacement,
                response
              );
            }
          });
      });
    } else if (custom.isCartPage || isSideCart) {
      if (custom.getAttribute("debugrec")) {
        console.log("recommendation request", {
          placementId: placementId,
          productId: productId,
          sectionId: sectionId,
          productLimit: productLimit,
          languageCode: languageCode,
          discountPlacement: discountPlacement,
          viewPage: 'Cart Page'
        });
      }
      nostojs((api) => {
        api
          .defaultSession()
          .viewCart()
          .setPlacements([placementId])
          .load()
          .then((response) => {
            if (custom.getAttribute("debugrec")) {
              console.log("recommendation response", response);
            }
            if (response) {
              custom_nosto.handleNostoProductResponse(
                placementId,
                sectionId,
                productLimit,
                doCarousel,
                languageCode,
                discountPlacement,
                response
              );
            }
          });
      });
    } else {
      if (custom.getAttribute("debugrec")) {
        console.log("recommendation request", {
          placementId: placementId,
          productId: productId,
          sectionId: sectionId,
          productLimit: productLimit,
          languageCode: languageCode,
          discountPlacement: discountPlacement,
          viewPage: 'Front Page - Else Condition'
        });
      }
      nostojs((api) => {
        api
          .defaultSession()
          .viewFrontPage()
          .setPlacements([placementId])
          .load()
          .then((response) => {
            if (custom.getAttribute("debugrec")) {
              console.log("recommendation response", response);
            }
            if (response) {
              custom_nosto.handleNostoProductResponse(
                placementId,
                sectionId,
                productLimit,
                doCarousel,
                languageCode,
                discountPlacement,
                response
              );
            }
          });
      });
    }
  },
  callNostoSection: function (placementId, sectionId, type) {
    if (!type) {
      return;
    }

    custom.hideVisible("shopify-section-" + sectionId);
    let nosto_debug = custom.getAttribute("nosto_debug");
    if (nosto_debug) {
      let json = { handle: nosto_debug };
      custom_nosto.handleNostoSectionResponse(json, sectionId, type);
    } else if (custom.nostoApiKey != "") {
      nostojs((api) => {
        api
          .defaultSession()
          .setResponseMode("HTML")
          .viewFrontPage()
          .setPlacements([placementId])
          .load()
          .then((response) => {

            if (response.recommendations.hasOwnProperty(placementId)) {

              let json = JSON.parse(response.recommendations[placementId]);
              custom_nosto.handleNostoSectionResponse(json, sectionId, type);
            } else {
              custom.hide("shopify-section-" + sectionId);
            }
          })
          .catch((error) => {
            console.error("Error calling Nosto:", error);
          });
      });
    } else {
      custom.hide("shopify-section-" + sectionId);
    }
  },
  handleNostoSectionResponse: function (json, sectionId, type) {
    custom.hideVisible("shopify-section-" + sectionId);

    let handle = json.handle;
    if (!handle) {
      return false;
    }
    if (type == 'collection_list_nosto') {
      custom.callStorefrontAPI(handle, sectionId, type);
    } else {
      custom.callMetaobjectAPI(handle, sectionId, type);
    }
  },
  handleNostoDefault: function (metaobject, collectionSectionid, type) {
    if (metaobject && metaobject[type] && metaobject[type].length == 0) {
      console.error(`${type} failed to get metaobject`)
      custom.hide(collectionSectionid);
      return false;
    }
    return true;
  },
  updateNostoSlideshow: function () {
    const slideshows = document.querySelectorAll(".nosto-slideshow");
    slideshows.forEach((slideshow) => {
      const image = slideshow.querySelector(".product-primary-image");
      const info = slideshow.querySelector(".product-card-info");
      if (image && info) {
        const imageHeight = image.clientHeight;
        const infoHeight = info.clientHeight;
        const newHeight = imageHeight + infoHeight + 50;
        const viewport = slideshow.querySelector(".flickity-viewport");
        if (viewport) {
          viewport.style.height = `${newHeight}px`;
        }
      }
    });
  },
  trackNostoSearchSubmit: function (searchTerm) {
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoSearchSubmit: ', 'apicall': 'api.recordSearchSubmit', 'searchTerm': searchTerm });
    }
    nostojs(api => {
      const query = searchTerm
      api.recordSearchSubmit(query)
    })
  },
  trackNostoRecommendationsCartAdd: function (productId, slotId) {
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoRecommendationsCartAdd: ', 'apicall': 'api.recommendedProductAddedToCart', 'productId': productId, 'slotId': slotId });
    }
    nostojs(api => {
      api.recommendedProductAddedToCart(productId, slotId);
    });
  },
  trackNostoCart: function (cartItems) {
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoCart: ', 'apicall': 'api.setCart', 'cart_items': cartItems });
    }
    nostojs(api => {
      api.defaultSession()
        .setCart({
          items: cartItems
        })
        .viewCart()
        .update()
    });
  },
  trackNostoCartAdd: function (productId, url) {
    if (url.indexOf("http" == -1)) {
      //if the url doesnt contain the domain, add it here
      let domain = window.location.origin;
      url = domain + url;
    }
    let searchPage = window.location.href.indexOf("/search") != -1;
    let categoryPage = window.location.href.indexOf("/collections") != -1;
    let type = '';

    if (searchPage) {
      type = 'serp';
    }
    else if (categoryPage) {
      type = 'category';
    }
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoCartAdd ', 'apicall': 'api.recordSearchAddToCart', 'productId': productId, 'url': url, 'type': type });
    }

    nostojs(api => {
      let hit = {
        productId: productId,
        url: url,
      }
      api.recordSearchAddToCart(type, hit)
    });
  },
  trackNostoSearchClick: function (productId, url, type) {
    if (url.indexOf("http" == -1)) {
      //if the url doesnt contain the domain, add it here
      let domain = window.location.origin;
      url = domain + url;
    }
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoSearchClick: ', 'apicall': 'api.recordSearchClick', 'productID': productId, 'URL': url, 'Type': type });
    }
    nostojs(api => {
      let hit = {
        productId: productId,
        url: url,
      }
      api.recordSearchClick(type, hit);
    });
  },
  trackNostoCategoryClick: function (productId, url) {
    if (url.indexOf("http" == -1)) {
      //if the url doesnt contain the domain, add it here
      let domain = window.location.origin;
      url = domain + url;
    }
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoSearch: ', 'apicall': 'api.recordSearch', 'productId': productId, 'url': url });
    }

    nostojs(api => {
      let hit = {
        productId: productId,
        url: url,
      }
      api.recordSearchClick('category', hit);
    });
  },
  trackNostoCategoryPage: function (searchRequest, searchResult) {//Impressions
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoCategoryPage: ', 'apicall': 'api.recordSearch', 'SearchRequest': searchRequest, 'SearchResult': searchResult });
    }
    let option = {};
    option.isKeyword = false;
    nostojs(async (api) => {
      api.recordSearch(
        'category',
        searchRequest,
        searchResult,
        {
          isKeyword: false
        }
      )
    });
  },
  trackNostoSearch: function (type, searchRequest, searchResult, options, searchTerm) {//Impressions
    searchRequest = {
      query: searchTerm,
      products: {
        sort: [{ field: "price", order: "asc" }]
      }
    }

    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': 'trackNostoSearch: ', 'apicall': 'api.recordSearch', 'Type': type, 'SearchRequest': searchRequest, 'SearchResult': searchResult, 'options': options });
    }

    nostojs(async (api) => {
      api.recordSearch(
        type,
        searchRequest,
        searchResult,
        options
      )
    })
  },
  trackNostoClick: function (slotId, productId) {
    if (custom.getAttribute("debug_tracking")) {
      console.log({ 'method': "trackNostoClick", 'apicall': 'api.recordAttribution', 'SlotID': slotId, 'ProductID': productId });
    }
    nostojs(api => api.recordAttribution({
      type: "vp",
      target: productId,
      ref: slotId,
      refType: "api"
    })
      .done()
    );
  },
  removePageParam: function () {
    const url = new URL(window.location);
    url.searchParams.delete('page');
    window.history.replaceState({}, document.title, url.toString());
  },
  filterNostoProducts: function (
    collectionId,
    resultsId,
    sort,
    pageNum,
    filter,
    filterValid,//This is needed to be able to use a valid json object. The above filter is for graphQL which is not a valid json structure
    use_default,
    allow_scroll
  ) {
    if(custom.getAttribute("page") && !custom_nosto.collectionPageLoaded){
      const pageValue = parseInt(custom.getAttribute("page"), 10);
      if (isNaN(pageValue) || pageValue <= 1) {
        pageNum = 0;
        custom_nosto.removePageParam();
      } else {
        pageNum = pageValue - 1;
        const url = new URL(window.location); 
        url.searchParams.set('page', pageNum + 1);
        window.history.replaceState({}, document.title, url.toString());
      }
    } else {
      if( pageNum > 0 ){ //add page={pageNum+1} to url without refreshing the page
        const url = new URL(window.location);
        url.searchParams.set('page', pageNum + 1);
        window.history.replaceState({}, document.title, url.toString());
      } else {
        custom_nosto.removePageParam();
      }
    }
    custom_nosto.collectionPageLoaded = true;
    if (sort) {
      custom.filters.sort = sort;
    }
    if (!custom.pageSet) {
      let sortFilter = custom.getAttribute('filter.sort');
      let filterUrl = custom.getAttribute('filter');
      if (sortFilter) {
        custom.filters.sort = sortFilter;
        let sortContainer = document.getElementById('nosto-sort-list');
        if (sortContainer) {
          window.onload = function () {
            sortContainer.querySelectorAll('li').forEach((item) => {
              let btn = item.querySelector('.custom-select--item-active');
              let val = btn.getAttribute('data-value');
              if (val == sortFilter) {
                document.getElementById('nosto-search').querySelector('.custom-select--text').innerHTML = btn.innerHTML;
              }
            });
          };
        }
      }
      if (filterUrl) {
        let filters = filterUrl.split("||");
        custom.filtersArray = filters;
        filter = "";
        filters.forEach((ft, ftidx) => {
          if (ft) {
            let filterArr = ft.split("*");
            let param = filterArr[0];
            let val = filterArr[1];
            let outputValue = `"${val}"`;
            if (val && val.indexOf(",") != -1) {
              outputValue = "";
              let valArr = val.split(",");
              valArr.forEach((output, idx) => {
                outputValue += `"${output}"`
                if ((idx + 1) < valArr.length) {
                  outputValue += ',';
                }
              });
            }
            filter += `{field: "${param}",value: [${outputValue}]}`;
            if ((ftidx + 1) < filters.length) {
              filter += ',';
            }
          }
        })
        filter = `[${filter}]`;
        let jsonStr = custom.convertFilterToValidJson(filter);
        filterValid = jsonStr;
      }
    }

    if (filter) {
      custom.filters.filter = filter;
    }
    if (filterValid) {
      custom.filters.filterValid = filterValid;
    }
    custom.pageSet = true;
    if (collectionId) {
      custom.filters.collectionId = collectionId;
    }
    if (resultsId) {
      custom.filters.resultsId = resultsId;
    }

    
    custom.filters.pageNum = pageNum;
    collectionId = custom.filters.collectionId;
    resultsId = custom.filters.resultsId;
    sort = custom.filters.sort;
    pageNum = custom.filters.pageNum;
    filter = custom.filters.filter;
    if (filter) {
      let filterObj = JSON.parse(custom.filters.filterValid);
      let activeFacets = document.querySelector('.active-facets');
      activeFacets.innerHTML = "";
      if (activeFacets) {
        let divs = activeFacets.querySelectorAll('.active-facets__button');
        divs.forEach(div => div.remove());
        filterObj.forEach((ft) => {
          ft.value.forEach((val) => {
            let filterRemove = custom.fetchLinkTemplate(val, ft.field);
            let testElem = document.getElementById(`${ft.field}${val}`);
            if (testElem) {
              activeFacets.insertAdjacentHTML("afterbegin", filterRemove);
            }
          });
        });
      }
    }
    let resultsDiv = document.getElementById(resultsId);
    if (!resultsDiv) {
      return false;
    }
    if (allow_scroll) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }

    let field = "price";
    if (sort == "newest") {
      sort = "desc";
      field = "datePublished";
    }
    if (sort == 'highest_discount') {

      field = "stats.discount";
      sort = "desc";
    }

    let filterJson = "";
    if (filter) {
      filterJson = `filter: ${filter}`;
    }

    let sortField = "";
    let categoryField = `categoryId: "${collectionId}"`;
    if (sort != "") {
      sortField = `
        sort: [{field: "${field}", order: ${sort}}]
      `;
    }
    if (!collectionId) {
      categoryField = "";
    }
    let accountId = custom.currAccountId;
    if (!accountId) {
      accountId = theme.settings.nostoId;
      if (use_default) {
        accountId = theme.settings.defaultNostoId;
        localStorage.setItem("use-default-account-id", 1);//If we set default this was due to a fail request so make sure we use the default account id from now on
      }
    }
    if (localStorage.getItem("use-default-account-id") == 1) {
      accountId = theme.settings.defaultNostoId;
    }
    let searchQuery = "";
    if (custom.getAttribute('q')) {
      searchQuery = `query: "${custom.getAttribute('q')}",`;
    }
    let pageCt = custom.paginationCt ? custom.paginationCt : 0;
    pageNum = pageNum ? pageNum : 0;
    let fromCt = pageNum * pageCt;
    let query = `query {
        search (accountId: "${accountId}", ${searchQuery}
          products: {
            ${categoryField}${sortField}
            size: ${custom.paginationCt}
            from: ${fromCt}
            ${filterJson}
          }) 
          {
            redirect
            products {
              hits {
                name
                thumbUrl
                price
                listPrice
                productId
                url
              }
              total
            }
        }
      }`;

    resultsDiv.innerHTML = "";
    if (custom.getAttribute("debugrec")) {
      console.log("graphql request", query);
    }
    fetch("https://search.nosto.com/v1/graphql", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: query,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        let redirect;
        if (result && result.data && result.data.search) {
          redirect = result.data.search.redirect;
        }
        if (redirect) {
          location.href = redirect;
          return;
        }
        let searchTerm = custom.getAttribute('q');
        if (custom.getAttribute('q') && !custom.getAttribute("from_key")) {
          custom_nosto.trackNostoSearchSubmit(searchTerm);
        }
        if (custom.getAttribute("from_key") == 'true') {
          let option = {};
          option.isKeyword = true;
          custom_nosto.trackNostoSearch("autocomplete", query, result.data.search, option, searchTerm);
        }
        else if (custom.getAttribute('q')) {
          custom_nosto.trackNostoSearch("serp", query, result.data.search, null, searchTerm);
        }

        if (custom.getAttribute("debugrec")) {
          console.log("graphql response", result);
        }
        let hasProducts = false;
        if (result.data.search && result.data.search.products) {
          let hits = result.data.search.products.hits;
          hasProducts = hits.length > 0;
        }
        let errors = result.errors;
        let hasError = false;
        if (errors && errors.length > 0) {
          hasError = true;
          console.error('Nosto API fetch failed with error: ' + JSON.stringify(errors, null, 4));
        }
        if (custom.getAttribute("no-nosto") == "true") {//Use this to emulate nosto being down
          custom_nosto.handleNostoNoResults();
        }
        else if (hasError && !hasProducts) {
          if (!use_default) {
            custom_nosto.filterNostoProducts(collectionId, resultsId, sort, pageNum, filter, filterValid, true);
          } else {
            custom_nosto.handleNostoNoResults();
          }
        }
        else if (result && result.data) {
          let categoryQuery = {
            products: {
              "categoryId": collectionId,
              "size": custom.paginationCt,
              "from": fromCt
            }
          };
          if (filter) {
            let filterNoQuotesConverted = sanitizeAndConvertToJson(filterJson.replace("filter: ", ""));
            let jsonTrackFilter = JSON.parse(filterNoQuotesConverted);
            categoryQuery = {
              products: {
                "categoryId": collectionId,
                "size": custom.paginationCt,
                "from": fromCt,
                "filter": jsonTrackFilter
              }
            };
          }
          if (!custom.getAttribute('q')) {
            custom_nosto.trackNostoCategoryPage(categoryQuery, result.data.search);
          }
          custom.currAccountId = accountId;
          let hits = result.data.search.products.hits;
          let totalProducts = result.data.search.products.total;
          if (totalProducts == 0) {
            custom_nosto.handleNostoNoResults();
          }
          let numberOfPages = Math.ceil(totalProducts / custom.paginationCt);
          let shop_symbol = custom.fetchShopSymbol();
          let promotionsShown = [];
          if (custom.getAttribute('q')) {
            let resultTxtElem = document.querySelector('.template-header--description');
            if (resultTxtElem) {
              //search the text and remove all numeric digits, the prepend the text with hits.length
              let resultTxt = resultTxtElem.innerHTML;
              resultTxt = resultTxt.replace(/(\d+)/g, '');
              resultTxt = `${totalProducts} ${resultTxt}`;
              resultTxtElem.innerHTML = resultTxt;
              resultTxtElem.style.display = 'block';
            }
          }
          // Listen for when all PDP items have been fetched
          var fetchCount = hits.length -1;
          let completionCallback = () => {
            fetchCount --;
            if (fetchCount == 0) {
              custom.callJudgeMeScript();
            }
          };
          hits.map((product, idx) => {
            if (collectionPromotions && collectionPromotions[idx + 1]) {
              custom.generateFillerTile(collectionPromotions[idx + 1]);
              promotionsShown.push(idx + 1);
            }
            let productUrl = product.url;
            productArr = productUrl.split("/");
            let productHandle = productArr[productArr.length - 1];
            let isGallery = theme.settings.is_gallery == 'true';
            if (productHandle) {
              document.getElementById("nostoProducts").innerHTML +=
              custom.prefetchProduct(productHandle, product);
              productCardElems.getPdpItem(productHandle, false, null, null,null, false, isGallery, false, completionCallback);
            }
          });
          collectionPromotions.forEach((collectionPromo, idx) => {
            if (idx + 1 > hits.length && !promotionsShown.includes(idx + 1)) {
              custom.generateFillerTile(collectionPromo);
            }
          });

          let pages = "";
          let dotsHTML = `<span class="pagination__link pagination__link--disabled h6">…</span>`;
          let firstPage = `<span class="page "><a onclick="custom_nosto.filterNostoProducts('${collectionId}', '${resultsId}', '${sort}',0,null,null,false,true);" title="">1</a></span>`
          let lastPage = `<span class="page "><a onclick="custom_nosto.filterNostoProducts('${collectionId}', '${resultsId}', '${sort}',${numberOfPages - 1},null,null,false,true);" title="">${numberOfPages}</a></span>`
          let nextLink = `<span class="next"><a  onclick="custom_nosto.filterNostoProducts('${collectionId}', '${resultsId}', '${sort}',${pageNum + 1},null,null,false,true);" title="">
         <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 0.818115L6 5.81812L1 10.8181" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg><span class="visually-hidden">Page suivante</span></a></span>`;

          let nextLinkDisabled = `<span class="next">
          <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M1 0.818115L6 5.81812L1 10.8181" stroke="var(--color-border)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
           </svg></span>`;

          let prevLinkDisabled = `<span class="prev"><svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 0.818115L1 5.81812L6 10.8181" stroke="var(--color-border)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg></span>`
          let prevLink = `<span class="prev"><a onclick="custom_nosto.filterNostoProducts('${collectionId}', '${resultsId}', '${sort}',${pageNum - 1},null,null,false,true);" title="">
          <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 0.818115L1 5.81812L6 10.8181" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg><span class="visually-hidden">Page précédente</span></a></span>`
          for (i = 0; i < numberOfPages; i++) {
            if (numberOfPages < 6) {
              let currentClass = i == pageNum ? "current" : "";
              pages += `<span class="page ${currentClass}"><a onclick="custom_nosto.filterNostoProducts('${collectionId}', '${resultsId}', '${sort}',${i},null,null,false,true);" title="">${i + 1}</a></span>`

            } else {
              if (pageNum < 5) {//Always show the and last page
                if (i < 5) {
                  if (i == 0 && pageNum > 0) {
                    pages += prevLink;
                  } else if (pageNum == 0) {
                    pages += prevLinkDisabled;
                  }

                  let currentClass = i == pageNum ? "current" : "";
                  pages += `<span class="page ${currentClass}"><a onclick="custom_nosto.filterNostoProducts('${collectionId}', '${resultsId}', '${sort}',${i},null,null,false,true);" title="">${i + 1}</a></span>`
                }
                if (i == 6) {
                  pages += dotsHTML + lastPage;
                }
              }
              else {
                if (i == 0) {
                  pages += prevLink + firstPage + dotsHTML;
                }
                if (i > (pageNum - 3) && i < (pageNum + 3)) {
                  let currentClass = i == pageNum ? "current" : "";
                  pages += `<span class="page ${currentClass}"><a onclick="custom_nosto.filterNostoProducts('${collectionId}', '${resultsId}', '${sort}',${i},null,null,false,true);" title="">${i + 1}</a></span>`
                } else if (i == numberOfPages - 1 && numberOfPages > pageNum + 3) {
                  pages += dotsHTML + lastPage;
                }
                // pages += dotsHTML + lastPage;
              }
              if (i == (numberOfPages - 1) && pageNum != (numberOfPages - 1)) {
                pages += nextLink;
              } else if (i == (numberOfPages - 1) && pageNum == (numberOfPages - 1)) {
                pages += nextLinkDisabled;
              }
            }
          }
          document.getElementById("nosto-collection-pagination").innerHTML =
            pages;

          document.getElementById("totalProducts").innerHTML = totalProducts;
          let productText = document.getElementById('productText').innerHTML;

          document.querySelector('.facets__label').innerHTML = `${totalProducts} ${productText}`;
          if (!custom.filtersChecked) {
            custom.checkFilters(custom.filtersArray);
          }
        } else {
          custom_nosto.handleNostoNoResults(collectionId);
        }
      });
  },
  handleNostoNoResults: function () {
    let handle = location.href.split('/').pop().split('?')[0];
    //location.href = '/pages/collection-no-nosto/' + handle;
  },
  filterNostoSearch: function (searchTerm, resultsDiv, sort, limit, use_default) {
    let searchPage = window.location.href.indexOf("/search") != -1;
    if (!searchPage) {
      resultsDiv.innerHTML = `<div id="search-box"></div>`;
      resultsDiv = document.getElementById("search-box");
    }
    let field = "price";
    if (sort == "newest") {
      sort = "desc";
      field = "datePublished";
    }

    let accountId = custom.currAccountId;
    if (!accountId) {
      accountId = theme.settings.nostoId;
      if (use_default) {
        accountId = theme.settings.defaultNostoId;
      }
    }
    if (localStorage.getItem("use-default-account-id") == 1) {
      accountId = theme.settings.defaultNostoId;
    }
    if (!limit) {
      limit = 140;
    }
    let query = `query ($query: String) {
        search (
          accountId: "${accountId}", 
          products: {
            size: ${limit}
          }
          query: $query
        ) {
          keywords {
            hits {
              keyword
            }
          }
          redirect
          products {
            hits {
              name
              thumbUrl
              price
              listPrice
              productId
              url
            }
            total
          }
        }
      }`;
    if (sort && sort != "") {
      query = `query ($query: String) {
        search (
          accountId: "${accountId}", 
          query: $query,
          products: {
            sort: [{field: "${field}", order: ${sort}}]
          }) {
          keywords {
            hits {
              keyword
            }
          }
          redirect
          products {
            hits {
              name
              thumbUrl
              price
              listPrice
              productId
              url
            }
            total
          }
        }
      }`;
    }

    if (!searchPage) {
      resultsDiv.innerHTML = `<div><ul id="nostoKeywords"></ul></div>`;
    }

    fetch("https://search.nosto.com/v1/graphql", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: query,
        variables: {
          query: searchTerm,
        },
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        let errors = result.errors;
        let hasError = false;
        if (errors && errors.length > 0) {
          hasError = true;
          console.error('Nosto API fetch failed with error: ' + JSON.stringify(errors, null, 4));
        }
        if (hasError) {
          if (!use_default) {
            custom_nosto.filterNostoSearch(searchTerm, resultsDiv, sort, limit, true);
          }
        } else {
          if (custom.getAttribute('q') && !custom.getAttribute("from_key")) {
            let redirect;
            if (result && result.data && result.data.search) {
              redirect = result.data.search.redirect;
            }
            if (redirect) {
              location.href = redirect;
            } else {
              custom_nosto.trackNostoSearchSubmit(searchTerm);
            }
          }
          if (custom.getAttribute("from_key") == 'true') {
            let option = {};
            option.isKeyword = true;
            custom_nosto.trackNostoSearch("autocomplete", query, result.data.search, option, searchTerm);
          }
          else if (custom.getAttribute('q')) {
            custom_nosto.trackNostoSearch("serp", query, result.data.search, null, searchTerm);
          } else {//Non search page
            custom_nosto.trackNostoSearch("autocomplete", query, result.data.search, null, searchTerm);
          }
          custom.currAccountId = accountId;
          let hits = result.data.search.products.hits;
          let keywords_nosto = result.data.search.keywords?.hits;
          let searchResults = "";

          if (!searchPage) {
            let nostoKeywordsElem = document.getElementById("nostoKeywords");
            if (nostoKeywordsElem) {
              nostoKeywordsElem.innerHTML = "";
              keywords_nosto?.map((item) => {
                let keyword = item.keyword;
                let locale = "";
                if (theme.settings.locale) {
                  custom.updateLocale();
                  locale = '/' + theme.settings.locale
                }
                nostoKeywordsElem.innerHTML += `<li><a onclick="custom.linkToKeywordSearch('${locale}/search?q=${keyword}&from_key=true');" href="#">${keyword}</a></li>`;
              });
            }
            resultsDiv.innerHTML += `<div id="search-results"></div>`;
            searchResults = document.getElementById("search-results");
            searchResults.innerHTML = "";
          }
          if (hits.length == 0) {
            notFound = document.getElementById("notFound");
            if (notFound) {
              notFound.classList.add("show");
            }
          }
          else {
            hits.map((product) => {
              let productUrl = product.url;
              productArr = productUrl.split("/");
              let productHandle = productArr[productArr.length - 1];
              let nostoSearchElem = document.getElementById("nostoSearch");
              if (nostoSearchElem && searchPage) {
                if (productHandle) {
                  nostoSearchElem.innerHTML += custom.prefetchProduct(
                    productHandle,
                    product
                  );
                  productCardElems.getPdpItem(productHandle, false, null, null, null, true);
                }
              } else {
                if (productHandle) {
                  searchResults.innerHTML += `<div class="product-${productHandle}"></div>`;
                  productCardElems.getPdpItem(productHandle, true, null, null, null, true);
                }
              }
            });
          }
        }
      });
  },
  updateNostoSearch: function (terms, resultsDiv, sort) {
    custom_nosto.filterNostoSearch(terms, resultsDiv, sort);
  },
  updateFilterItem: function () {
    custom_nosto.refreshProducts();
    custom_nosto.updateFilterUrl();
    custom_nosto.updateFilters();
  },
  updateFilterUrl: function (pageNum) {
    let responseUrl = "?filter=";
    if (custom.filters.filterValid) {
      let json = JSON.parse(custom.filters.filterValid);
      json.forEach((filter) => {
        let values = filter.value;
        let param = filter.field;
        responseUrl += `||${param}*${values}`
      });
    }
    if (custom.getAttribute('q')) {
      responseUrl += `&q=${custom.getAttribute('q')}`;
    }
    if (pageNum) {
      responseUrl += `&page=${pageNum}`;
    }
    window.history.pushState('page2', 'Title', responseUrl)
  },
  removeFilter: function (currVal, currField) {
    let cbId = currField + currVal;
    let elem = document.getElementById(cbId);
    if (elem) {
      elem.checked = false;
      custom_nosto.refreshProducts();
      document.querySelector('.click-capture').click()
    }
    custom_nosto.updateFilterUrl();
  },
  getFilterQuery: function (use_default) {
    let collectionId = this.currCollectionId;
    let categoryFilter = "";
    if (collectionId) {
      categoryFilter = `products:{
        categoryId:"${collectionId}"
        filter: ${custom.filters.filter}
      }`;
    }
    let accountId = custom.currAccountId;
    if (!accountId) {
      accountId = theme.settings.nostoId;
      if (use_default) {
        accountId = theme.settings.defaultNostoId;
      }
    }
    if (localStorage.getItem("use-default-account-id") == 1) {
      accountId = theme.settings.defaultNostoId;
    }
    let searchQuery = "";
    if (custom.getAttribute('q')) {
      searchQuery = `query: "${custom.getAttribute('q')}",`;
    }
    let query = `query {
      search(
        ${categoryFilter}${searchQuery}
        accountId: "${accountId}") {
        products {
          facets {
            ... on SearchTermsFacet {
              id
              field
              type
              name
              data {
                value
                count
              }
            }
          }
        }
      }
    }`;
    if (custom.getAttribute('debugrec')) {
      console.log('Filter Request Query:', query);
    }
    return query;
  },
  refreshProducts: function () {
    let mobileForm = document.getElementById("FacetFiltersFormMobile2");
    let textinputs = mobileForm
      ? mobileForm.querySelectorAll("input[type=checkbox]")
      : "";
    let checked = [].filter.call(textinputs, function (el) {
      return el.checked;
    });
    let jsonFilter = [];
    let jsonFilterValid = [];
    let allFilters = {};
    checked.forEach((input) => {
      let name = input.getAttribute("name");
      let value = input.getAttribute("value");
      if (!allFilters[name]) {
        allFilters[name] = [];
      }
      allFilters[name].push(value);
    });
    let idx = 0;
    let filtersCt = Object.keys(allFilters).length;
    for (var fieldName in allFilters) {
      idx++;
      if (allFilters.hasOwnProperty(fieldName)) {
        let values = JSON.stringify(allFilters[fieldName]);
        let json = `{ field: "${fieldName}", value: ${values} }`;
        let jsonValid = `{ "field": "${fieldName}", "value": ${values} }`;
        if (idx < filtersCt) {
          jsonValid += ",";
        }
        jsonFilter += json;
        jsonFilterValid += jsonValid;
      }
    }
    let currentFilter = localStorage.getItem("current-product-filter");
    let storeFilter = JSON.stringify(jsonFilter);
    if (storeFilter != currentFilter) {
      localStorage.setItem("current-product-filter", storeFilter);
      jsonFilter = `[${jsonFilter}]`;
      jsonFilterValid = `[${jsonFilterValid}]`;
      custom_nosto.filterNostoProducts(null, null, null, null, jsonFilter, jsonFilterValid);
    }
  }
}